import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";

export const lehtoCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			configuratorEnabled: true,
			surveysEnabled: true
		},
		spc: {
			processImprovementsEnabled: true
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
		workspacesEnabled: true,
	},
} as const;
